const actions = {
  fetchRoomInWishlist({ state, commit }) {
    App.es6.shared.wish_list.then(api => {
      commit('setIsRoomFavourite', api.isFavourite(state.roomId));
    });
  },

  toggleWishlist({ state, commit }) {
    App.es6.shared.wish_list.then(api => {
      api.toggleSaved(state.roomId, { section: 'room_page_enquiry_form' })
        .then((isSaved) => {
          if (isSaved) {
            commit('setIsRoomFavourite', !state.isRoomFavourite);
          }
        });
    });
  },
};

export default actions;
